<script>
  export let statSubtitle = "Total value";
  export let statTitle = "—";
  export let statArrow = "up";
  export let statPercent = "";
  export let statPercentColor = "text-emerald-600";
  export let statDescription = "";
  export let statIconName = "far fa-chart-bar";
  export let statIconBg = "bg-emerald-50";
  export let statIconColor = "text-moira";
  export let showPercent = true; // Whether to show the % sign
  export let showArrow = true; // Whether to show the arrow
</script>

<div class="card card-pad h-full">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <p class="text-xs font-semibold uppercase tracking-wider text-ink-tertiary">
        {statSubtitle}
      </p>
      <p class="text-2xl font-bold text-ink tnum mt-1.5 truncate">
        {statTitle}
      </p>
    </div>
    <div class="shrink-0 w-11 h-11 rounded-xl inline-flex items-center justify-center {statIconBg}">
      <i class="{statIconName} {statIconColor}"></i>
    </div>
  </div>
  {#if statPercent !== "" || statDescription}
    <p class="text-sm mt-4 flex items-baseline gap-1.5 flex-wrap">
      {#if statPercent !== ""}
        <span class="{statPercentColor} font-medium tnum">
          {#if showArrow}
            <i class="fas fa-arrow-{statArrow === 'up' ? 'up' : 'down'} text-xs mr-0.5"></i>
          {/if}
          {statPercent}{#if showPercent}%{/if}
        </span>
      {/if}
      <span class="text-ink-tertiary">
        {statDescription}
      </span>
    </p>
  {/if}
</div>
